import { LANDING } from "shared/constants/permalinks"

import { useNavigateToPermalink } from "features/navigation/model/useNavigateToPermalink"

import { EmailVerificationPageModel } from "../EmailVerificationPage"

export function useEmailVerificationPageModel(): EmailVerificationPageModel {
  const { navigate: navigateToHomepage } = useNavigateToPermalink(LANDING)

  return {
    navigateToHomepage
  }
}
